/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Cell, Grid, VFlow } from 'bold-ui'
import { DateField, TextAreaField } from 'components/form'
import { useAtendimentoContext } from 'hooks/atendimento-context/useAtendimentoContext'
import { max } from 'lodash'
import { Fragment } from 'react'
import { toDate } from 'util/date/formatDate'
import { MetaPath } from 'util/metaPath'

import { FactoryResultadoExameEspecificoFieldProps, ResultadoExameEspecificoModel } from '../../model-resultadosExames'
import { getResultadoExameEspecificoField } from '../../util-resultadosExames'
import { ResultadoExameExpandableContainer } from '../components/ResultadoExameExpandableContainer'

interface ResultadoExameEspecificoFieldProps extends Omit<FactoryResultadoExameEspecificoFieldProps, 'name'> {
  name: MetaPath<ResultadoExameEspecificoModel>
  disableOtherFields: boolean
  hasSolicitacao?: boolean
}

export const ResultadoExameEspecificoField = (props: ResultadoExameEspecificoFieldProps) => {
  const { name, exame, hasSolicitacao, dataSolicitacao, dataRealizado, disableOtherFields, expanded } = props

  const {
    atendimentoProfissional: { iniciadoEm },
    cidadao: { dataNascimento },
  } = useAtendimentoContext()

  const ResultadoExameEspecificoField = getResultadoExameEspecificoField(exame)

  const dataNascimentoAsDate = toDate(dataNascimento)

  return (
    ResultadoExameEspecificoField && (
      <Fragment>
        <ResultadoExameEspecificoField
          name={name.resultado}
          exame={exame}
          expanded={expanded}
          dataSolicitacao={dataSolicitacao}
          dataRealizado={dataRealizado}
        />

        <ResultadoExameExpandableContainer expanded={expanded}>
          <VFlow
            style={css`
              margin-top: 1rem;
            `}
          >
            <TextAreaField
              name={name.descricao}
              label='Descrição'
              maxLength={2000}
              disabled={disableOtherFields}
              style={css`
                resize: vertical;
              `}
            />

            <Grid gap={1.5}>
              {!hasSolicitacao && (
                <Fragment>
                  <Cell size={5}>
                    <DateField
                      name={name.dataSolicitado}
                      label='Solicitado em'
                      disabled={disableOtherFields}
                      minDate={dataNascimentoAsDate}
                      maxDate={iniciadoEm}
                      inline
                    />
                  </Cell>

                  <Cell size={7} />
                </Fragment>
              )}

              <Cell size={5}>
                <DateField
                  name={name.dataRealizado}
                  label='Realizado em'
                  disabled={disableOtherFields}
                  minDate={max([dataNascimentoAsDate, dataSolicitacao])}
                  maxDate={iniciadoEm}
                  required
                  inline
                />
              </Cell>
              <Cell size={5}>
                <DateField
                  name={name.dataResultado}
                  label='Resultado em'
                  disabled={disableOtherFields}
                  minDate={max([dataNascimentoAsDate, dataRealizado])}
                  maxDate={iniciadoEm}
                  inline
                />
              </Cell>
            </Grid>
          </VFlow>
        </ResultadoExameExpandableContainer>
      </Fragment>
    )
  )
}
